<template>
  <main>
    <Content class="contact-content">
      <h1>we'd like to hear from you!</h1>    
    </Content>
    <ContactForm />
    <div class="social">
      <!-- <a href="https://www.facebook.com/cityphography" class="messenger" target="_blank" ></a><span>|</span> -->
      <a href="https://www.facebook.com/cityphography" target="_blank">facebook</a><span>|</span>
      <a href="https://www.instagram.com/cityphography" target="_blank">instagram</a>
      <br>
      <span class="hashtag">#cityphography</span>
      <!-- <p>For frequently asked questions see the <router-link :to="{path: '/about', hash: '#faq'}">info</router-link> page.</p> -->
      <p>For frequently asked questions see the <router-link :to="{path: '/about', hash: '#faq'}">info</router-link> page.</p>
      
    </div>   
  </main>
</template>

<script>

import Content from '@/components/Content.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'Contact' ,
  components: {
    Content,
    ContactForm
  },
  metaInfo() {
    return {
      title: "contact - cityphography",
      meta: [        
        { vmid: "og:title", property: "og:title", content: "contact - cityphography" },
        { vmid: "description", name: "description", content: "Get in touch with us by submitting the form, or find us on social media (facebook or instagram)." },
        { vmid: "og:description", property: "og:description", content: "Get in touch with us by submitting the form, or find us on social media (facebook or instagram)." }                
      ],
    };
  },
}
</script>

<style lang="scss">
@media (max-width: $S) {
    .contact-content{
      padding-bottom: 0;

      h1{
        margin-top: 40px;
      }
    }    
}

.social{
  text-align: center;
  max-width: 500px;  
  margin: 0 auto;
  margin-top: 80px;
  font-size: 20px;
  padding: 0 30px;

  .messenger{
    width: 20px;
    height: 20px;
    display: inline-block;
    top: 5px;
    opacity: 0.5;
    transform: scale(0.8);
    position: relative;
    background: url(/img/iconmonstr-facebook-messenger-1.6cff5f79.svg);
    background-size: contain;

    &:hover{
      transform: scale(1);
    }
  }

  .hashtag{
    color: #d6d6d6;
    font-size: 14px;
    font-weight: bold;
  }

  span {
    padding: 0 5px;
  }

  a {
    font-family: Averia;
    cursor: pointer;
    
  }

  p {
    font-size: 14px;
    padding: 20px 0 40px 0;

    a {
      font-size: 18px;   
      color: var(--color-content-links);   

      &:hover{
        color: $orange;
      }
    }
  }
}

</style>